<script setup>
const route = useRoute()
const { isVisible, statusCode, returnTo, close } = useAuthFailure()
const { openAuthDialog } = useAuthDialog()

const isClientExperience = computed(() => {
  const layout = route.meta?.layout
  return layout === "client" || layout === "landing"
})

const title = computed(() => statusCode.value === 403
  ? "دسترسی حساب منقضی شده"
  : "نیاز به ورود مجدد")

const loginAgain = async () => {
  const target = returnTo.value || "/client-page"
  close()

  if (isClientExperience.value) {
    openAuthDialog(target)
    return
  }

  await navigateTo({
    path: "/panel-login",
    query: { redirect: target },
  })
}
</script>

<template>
  <VDialog
    :model-value="isVisible"
    persistent
    width="420"
    max-width="calc(100% - 28px)"
  >
    <VCard class="auth-failure" dir="rtl">
      <div class="auth-failure__icon">
        <VIcon icon="tabler-shield-lock" size="34" />
      </div>

      <div class="auth-failure__copy">
        <small>خطای احراز هویت {{ statusCode }}</small>
        <h2>{{ title }}</h2>
        <p>
          اعتبار ورود قبلی شما پایان یافته یا اطلاعات امنیتی حساب تغییر کرده است.
          برای ادامه، لطفاً دوباره وارد حساب شوید.
        </p>
      </div>

      <VAlert type="info" variant="tonal" density="compact">
        اطلاعات واردشده در صفحه تغییری نکرده، اما ممکن است پس از ورود نیاز به تکرار آخرین عملیات باشد.
      </VAlert>

      <VBtn
        block
        color="primary"
        size="large"
        rounded="lg"
        append-icon="tabler-login-2"
        @click="loginAgain"
      >
        ورود مجدد
      </VBtn>
    </VCard>
  </VDialog>
</template>

<style lang="scss" scoped>
.auth-failure{display:grid;gap:16px;padding:27px 25px 23px!important;border:1px solid rgba(var(--v-theme-primary),.13);border-radius:22px!important;background:linear-gradient(180deg,#fff,#fbfaff)!important;box-shadow:0 24px 70px rgba(41,33,72,.2)!important}.auth-failure__icon{display:grid;width:66px;height:66px;margin:auto;place-items:center;border-radius:20px;color:rgb(var(--v-theme-primary));background:rgba(var(--v-theme-primary),.1)}.auth-failure__copy{text-align:center}.auth-failure__copy small{color:rgb(var(--v-theme-primary));font-size:10px;font-weight:800}.auth-failure__copy h2{margin:6px 0;color:#352e47;font-size:19px}.auth-failure__copy p{margin:0;color:#7f788b;font-size:11px;line-height:2}.auth-failure :deep(.v-alert){border-radius:13px;font-size:10px;line-height:1.9}.auth-failure :deep(.v-btn){font-family:inherit;font-size:12px;font-weight:800}@media(max-width:420px){.auth-failure{padding:23px 18px 19px!important}.auth-failure__copy h2{font-size:17px}}
</style>
